import wave from "../../../../../assets/wave.png"; // Adjust the path as necessary
import PdfImage from "../../components/images/PdfImage";

const PdfBuilderWaveImage = ({ width = 32, height = 32, style = {} }) => (
  <PdfImage src={wave} width={width} height={height} style={style} />
);

export default PdfBuilderWaveImage;
